<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col">
            <div *ngIf="errorCode === '401'">
                <h1>Uh oh...</h1>
                <p *ngIf="customMessage">{{ customMessage }}</p>
                <p>You must be logged in to view this page.</p>
                <p>Please log in to see this page.</p>
                <div class="login" *ngIf="!userService.hasStudentExperience()">
                    <app-register
                        [showSocialIcons]="true"
                        [nextURL]="nextURL"
                        text="Teacher Login"
                    >
                    </app-register>
                </div>
                <span
                    class="login-separator"
                    *ngIf="!userService.hasStudentExperience()"
                    >or</span
                >
                <div class="login">
                    <app-register
                        [showSocialIcons]="true"
                        [nextURL]="nextURL"
                        [student]="true"
                        text="Student Login"
                    >
                    </app-register>
                </div>
                <a
                    class="homepage-link"
                    [routerLink]="[isStudent ? '/student' : '/']"
                    >Return to the PBS LearningMedia Homepage.</a
                >
            </div>
            <div *ngIf="errorCode === '404'">
                <h1>Uh oh...</h1>
                <p>
                    Seems like we can't locate the page you were looking for.
                    Either the page no longer exists, you mistyped the URL, or
                    the page has been moved.
                </p>
                <p *ngIf="customMessage">Error: {{ customMessage }}</p>
                <p>Sorry for the inconvenience!</p>
            </div>
            <div *ngIf="errorCode === '500'">
                <h1>Oops!</h1>
                <p>Something went wrong when trying to display the page</p>
                <p *ngIf="customMessage">Error: {{ customMessage }}</p>
                <p>
                    We apologize for the inconvenience and are working to fix
                    the issue.
                </p>
            </div>
            <div *ngIf="errorCode === '403'">
                <h1>Uh oh...</h1>
                <p>
                    It seems like this page is currently unavailable. Either you
                    do not have permissions to view it or the page has been
                    removed.
                </p>
                <p></p>
                <p *ngIf="customMessage">Error: {{ customMessage }}</p>
                <p>Sorry for the inconvenience!</p>
            </div>
        </div>
        <div class="col">
            <img
                *ngIf="errorCode === '401'"
                class="error-img"
                [src]="image401"
            />
            <img
                *ngIf="errorCode === '404'"
                class="error-img"
                [src]="image404"
            />
            <img
                *ngIf="errorCode === '403'"
                class="error-img"
                [src]="image404"
            />
            <img
                *ngIf="errorCode === '500'"
                class="error-img"
                [src]="image500"
            />
        </div>
    </div>
</div>
<app-footer></app-footer>
<app-simplified-footer></app-simplified-footer>
